import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { TailSpin } from "react-loader-spinner";

import { isVideoUrl } from "../../utility";

const MediaPreviewModal = ({
  isOpen,
  onClose,
  muted = true,
  autoPlay = true,
  controls = true,
  mediaFiles = [],
  currentIndex,
  setCurrentIndex,
}) => {
  const [loading, setLoading] = useState(true);
  const currentFile = mediaFiles[currentIndex];
  const isVideo = isVideoUrl(currentFile?.url);

  // Reset loading when switching file
  useEffect(() => {
    setLoading(true);
  }, [currentIndex]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Media Preview Modal"
        className="media-preview-modal"
        overlayClassName="media-preview-modal-overlay"
      >
        <div className="modal-content position-relative">
          {loading && (
            <div className="spinner media-spinner d-flex justify-content-center align-items-center">
              <TailSpin
                visible
                radius="2"
                color="#3e8993"
                ariaLabel="tail-spin-loading"
              />
            </div>
          )}
          {currentFile &&
            (isVideo ? (
              <video
                src={currentFile?.url}
                muted={muted}
                preload="auto"
                autoPlay={autoPlay}
                controls={controls}
                className="media-preview-element"
                onLoadedData={() => setLoading(false)}
                style={{ display: loading ? "none" : "block" }} // hide while loading
              />
            ) : (
              <img
                src={currentFile?.url}
                alt="Preview"
                className="media-preview-element"
                onLoad={() => setLoading(false)}
                style={{ display: loading ? "none" : "block" }}
              />
            ))}
          <button onClick={onClose} className="modal-close-button">
            <img
              alt="Close Modal"
              className="media-preview-close-icon"
              src="/images/simpleCrossWhite.svg"
            />
          </button>
          <button
            className="arrow-button arrow-button--left"
            disabled={currentIndex === 0}
            onClick={() => setCurrentIndex((prevIndex) => prevIndex - 1)}
          >
            <img
              alt="Previous"
              className="media-preview-arrow-icon"
              src="/images/previousArrowButtonWhite.svg"
            />
          </button>
          <button
            className="arrow-button arrow-button--right"
            onClick={() => setCurrentIndex((prevIndex) => prevIndex + 1)}
            disabled={currentIndex === mediaFiles.length - 1}
          >
            <img
              alt="Next"
              className="media-preview-arrow-icon"
              src="/images/nextArrowButtonWhite.svg"
            />
          </button>
        </div>
      </Modal>
    </>
  );
};

export default MediaPreviewModal;
